<template>
  <div id="LeftYellowLayout">
    <DefaultNavbar />
    <LeftYellowContainer>
      <router-view />
    </LeftYellowContainer>
    <DefaultFooter />
  </div>
</template>

<style lang="scss" scoped>
  .search-panel {
    position: relative;
    &::before {
      content: "";
      background-color: #ffbe17;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: -999px;
      border-radius: 20px;
    }
    .search-panel-body {
      position: relative;
      padding: 20px 15px;
      // display: flex;
    }
  }
</style>

<script>
import DefaultFooter from "@/components/DefaultFooter.vue";
import DefaultNavbar from "@/components/DefaultNavbar.vue";
// import YellowBannerContainer from "@/components/YellowBannerContainer.vue";
import LeftYellowContainer from "@/components/LeftYellowContainer.vue";

export default {
  name: "LeftYellowLayout",
  components: {
    DefaultFooter,
    DefaultNavbar,
    // YellowBannerContainer,
    LeftYellowContainer
  }
};
</script>
